import type { CustomDashboardsSchemaResponse } from '@cast/types';

export const MOCK_CUSTOM_DASHBOARDS_SCHEMA: CustomDashboardsSchemaResponse = {
  schema: {
    cubes: [
      {
        name: 'workloads',
        title: 'Workloads',
        type: 'view',
        measures: [
          {
            name: 'workloads.total_cost',
            title: 'Total cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'workloads.cpu_cost',
            title: 'CPU cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'workloads.ram_cost',
            title: 'RAM cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'workloads.gpu_cost',
            title: 'GPU cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'workloads.storage_cost',
            title: 'Storage cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'workloads.cpu_utilization_avg',
            title: 'Avg CPU utilization',
            type: 'number',
            format: 'percent',
            folder: 'Resource usage',
          },
          {
            name: 'workloads.ram_utilization_avg',
            title: 'Avg RAM utilization',
            type: 'number',
            format: 'percent',
            folder: 'Resource usage',
          },
        ],
        dimensions: [
          {
            name: 'workloads.cluster_name',
            title: 'Cluster name',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'workloads.namespace',
            title: 'Namespace',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'workloads.workload_name',
            title: 'Workload name',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'workloads.provider',
            title: 'Provider',
            type: 'string',
            folder: 'Details',
          },
          { name: 'workloads.Time', title: 'Time', type: 'time' },
        ],
        segments: [],
      },
      {
        name: 'clusters',
        title: 'Clusters',
        type: 'view',
        measures: [
          {
            name: 'clusters.total_cost',
            title: 'Total cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'clusters.cpu_cost',
            title: 'CPU cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'clusters.ram_cost',
            title: 'RAM cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'clusters.requested_cpu',
            title: 'Requested CPU',
            type: 'number',
            folder: 'Resource usage',
          },
          {
            name: 'clusters.used_cpu',
            title: 'Used CPU',
            type: 'number',
            folder: 'Resource usage',
          },
          {
            name: 'clusters.provisioned_cpu',
            title: 'Provisioned CPU',
            type: 'number',
            folder: 'Resource usage',
          },
          {
            name: 'clusters.requested_ram',
            title: 'Requested RAM',
            type: 'number',
            folder: 'Resource usage',
          },
          {
            name: 'clusters.used_ram',
            title: 'Used RAM',
            type: 'number',
            folder: 'Resource usage',
          },
        ],
        dimensions: [
          {
            name: 'clusters.name',
            title: 'Cluster name',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'clusters.provider',
            title: 'Provider',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'clusters.location',
            title: 'Location',
            type: 'string',
            folder: 'Details',
          },
          { name: 'clusters.Time', title: 'Time', type: 'time' },
        ],
        segments: [],
      },
      {
        name: 'nodes',
        title: 'Nodes',
        type: 'view',
        measures: [
          {
            name: 'nodes.total_cost',
            title: 'Total cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'nodes.cpu_cost',
            title: 'CPU cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
          {
            name: 'nodes.ram_cost',
            title: 'RAM cost',
            type: 'number',
            format: 'currency',
            folder: 'Costs',
          },
        ],
        dimensions: [
          {
            name: 'nodes.cluster_name',
            title: 'Cluster name',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'nodes.node_name',
            title: 'Node name',
            type: 'string',
            folder: 'Details',
          },
          {
            name: 'nodes.provider',
            title: 'Provider',
            type: 'string',
            folder: 'Details',
          },
          { name: 'nodes.Time', title: 'Time', type: 'time' },
        ],
        segments: [],
      },
    ],
  },
};
